import { editUserRowsPerPage } from "../services/UserService";

const handleChangeRowsPerPage = async (tableName, pages) => {
    const rowsPerPage = JSON.parse(localStorage.getItem("rowsPerPage") || "{}");
    rowsPerPage[tableName] = pages;
    localStorage.setItem("rowsPerPage", JSON.stringify(rowsPerPage));
    const userData = JSON.parse(localStorage.getItem('userData'));
    try {
        await editUserRowsPerPage({tableName, pages: pages}, userData?.uuid);
    } catch (err) {}
}

// The MIT version of MUI DataGrid throws when pageSize exceeds 100.
const MAX_ROWS_PER_PAGE = 100;

const getRowsPerPage = (tableName) => {
    const rowsPerPage = JSON.parse(localStorage.getItem("rowsPerPage") || "{}");
    const value = rowsPerPage[tableName];
    return value !== undefined ? Math.min(Number(value), MAX_ROWS_PER_PAGE) : null;
}

export { handleChangeRowsPerPage, getRowsPerPage }